<div class="flex h-full w-full overflow-hidden bg-gray-50">
  <!-- Left Sidebar -->
  <app-header-nav
    [isCollapsed]="isSidebarCollapsed"
    (toggleCollapse)="toggleSidebar()">
  </app-header-nav>

  <!-- Right Panel -->
  <div class="flex-1 flex flex-col min-w-0 h-full overflow-hidden">
    <!-- Top Header -->
    <header class="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-6 z-30 shrink-0">
      <div>
        <h2 class="text-lg font-semibold text-gray-800 m-0">Internal Portal</h2>
      </div>
      <div class="flex items-center gap-4">
        @if (currentUser) {
          <app-user-dropdown
            [user]="currentUser"
            (profileClick)="openProfile()"
            (logoutClick)="logout()">
          </app-user-dropdown>
        }
      </div>
    </header>

    <!-- Content Area. Cards are white, so the page behind them must not be. -->
    <main class="flex-1 overflow-y-auto p-6 bg-slate-50 [overscroll-behavior:contain]">
      <div class="w-full">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>

  <!-- User Profile Modal -->
  <p-dialog
    header="My Profile"
    [(visible)]="showProfileModal"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    styleClass="w-full max-w-md">
    <app-user-profile
      [user]="currentUser"
      (close)="closeProfile()"
      (save)="saveProfile()"
      (logout)="logout()">
    </app-user-profile>
  </p-dialog>
</div>
